/**
 * Duplicate-email cluster: accept one row, merge all rows, or add enrollment.
 */
export default function StagingMultiRowActionBanner({
  guidance,
  enrollmentDecision,
  onEnrollmentDecisionChange,
  onSelectSibling,
  onClusterAction,
  acting = false,
}) {
  if (!guidance?.show) return null;

  const actions = guidance.actions || [];
  const siblings = guidance.siblings || [];
  const isDuplicate = Number(guidance.emailOccurrenceCount) > 1;

  return (
    <div className="p-3 rounded-lg border border-indigo-300 bg-indigo-50/90 space-y-3">
      <div>
        <h3 className="font-semibold text-indigo-950 text-sm">
          Duplicate email
          {guidance.emailOccurrenceCount > 1
            ? ` · ${guidance.emailOccurrenceCount} rows`
            : ''}
        </h3>
        <p className="text-xs text-indigo-900 mt-1">{guidance.summary}</p>
      </div>

      {isDuplicate ? (
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            disabled={acting}
            onClick={() => onClusterAction?.('accept')}
            className="text-sm font-medium px-3 py-2 rounded-md border border-indigo-400 bg-white text-indigo-950"
          >
            Accept this record
          </button>
          <button
            type="button"
            disabled={acting}
            onClick={() => onClusterAction?.('merge')}
            className="text-sm font-medium px-3 py-2 rounded-md border border-indigo-400 bg-white text-indigo-950"
          >
            Merge from all rows
          </button>
          <button
            type="button"
            disabled={acting}
            onClick={() => onClusterAction?.('add_enrollment')}
            className="text-sm font-medium px-3 py-2 rounded-md border border-indigo-400 bg-indigo-700 text-white"
          >
            Add enrollment
          </button>
        </div>
      ) : null}

      {actions.length && !isDuplicate ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {actions.map((action) => {
            const selected =
              enrollmentDecision === action.recommendedEnrollment &&
              (guidance.primaryAction === action.id ||
                guidance.recommendedEnrollment === action.recommendedEnrollment);
            return (
              <button
                key={action.id}
                type="button"
                onClick={() => onEnrollmentDecisionChange?.(action.recommendedEnrollment)}
                className="text-left p-3 rounded-md border transition-all duration-200"
                style={{
                  borderColor: selected ? 'var(--color-primary, #4338ca)' : '#c7d2fe',
                  backgroundColor: selected ? '#e0e7ff' : '#fff',
                }}
              >
                <div className="font-medium text-sm text-indigo-950">{action.label}</div>
                <p className="text-xs text-indigo-800 mt-1">{action.description}</p>
              </button>
            );
          })}
        </div>
      ) : null}

      {siblings.length ? (
        <div className="text-xs text-indigo-900">
          <p className="font-medium mb-1">Other rows with this email</p>
          <ul className="space-y-1">
            {siblings.map((sib) => (
              <li key={sib.id}>
                <button
                  type="button"
                  className="underline"
                  onClick={() => onSelectSibling?.(sib.id)}
                >
                  {sib.externalKey || sib.id.slice(0, 8)}
                </button>
                <span className="opacity-80">
                  {' '}
                  · {sib.status}
                  {sib.ruleResult?.firstName || sib.ruleResult?.lastName
                    ? ` · ${[sib.ruleResult?.firstName, sib.ruleResult?.lastName]
                        .filter(Boolean)
                        .join(' ')}`
                    : ''}
                  {sib.ruleResult?.enrollment?.batchId
                    ? ` · batch ${sib.ruleResult.enrollment.batchId}`
                    : ''}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
